import * as React from 'react';
import { CSSObject } from 'styled-components';

export type IconProps = {
  width: number | string;
  height: number | string;
  viewBox?: string;
  cursor?: string;
  onClick?: () => void;
  fill?: string;
  strokeWidth?: string;
  backgroundFill?: string;
  style?: CSSObject;
};
type SvgIconProps = React.PropsWithChildren<IconProps>;
type SvgIconRef = SVGSVGElement;

const SvgIcon = React.forwardRef<SvgIconRef, SvgIconProps>(function SvgIcon(
  props,
  ref
) {
  const {
    children,
    viewBox = '0 0 32 32',
    width,
    height,
    cursor = 'inherit',
    onClick,
    ...rest
  } = props;

  return (
    <svg
      viewBox={viewBox}
      width={width}
      height={height}
      ref={ref}
      style={{ cursor }}
      onClick={onClick}
      {...rest}
    >
      {children}
    </svg>
  );
});

export default SvgIcon;
